<template>
  <div>
    <list-vue v-show="tabType === 1" @handleShow="handleShow" />
    <show-vue v-if="tabType === 2" @handleShow="handleShow" :rowItem="rowItem" />
  </div>
</template>

<script>
import listVue from './list.vue'
import showVue from './show.vue'
export default {
  components: {
    listVue,
    showVue
  },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>